/**
 *  API 统一管理
 * */

import $axios from '@/service/httpServer'


// 用户
export * from '@src/_common/api/user'

export * from './modules/contract'

export * from './modules/applyInfo'

export * from './modules/pay'

export * from './modules/visa'

export * from './modules/biddingInfo'

export * from './modules/corrupReport'

export const getCompanyList=params=>$axios.get(`/pdp/xcx/common/companies`, params)

export const getBannerList=params=>$axios.get(`/pdp/xcx/common/banners`, params)
